import classNames from 'classnames';

/**
 * This icon shouldn't be used for buttons.
 * In case you need clickable/hoverable color changing icon, use the IconButton component instead.
 * You CAN use it for showing tooltip on hover, but it shouldn't change it's styling on hover.
 * iconClass is the class name of the icon and should only identify the icon glyph.
 * @returns A span element with the icon.
 */
export const Icon = ({
  iconClass,
  color,
  'data-testid': dataTestId,
}: {
  iconClass: string;
  color?: string;
  'data-testid'?: string;
}) => {
  return (
    <span
      className='inline-flex w-[24px] h-[24px] p-[2px]'
      data-testid={dataTestId}
    >
      <i
        className={classNames(iconClass, 'w-[20px] h-[20px]')}
        style={{ color }}
      />
    </span>
  );
};
